import React, {ReactNode} from 'react';
import theme from './ReorderableList.module.scss';
import { arrayMove } from 'react-sortable-hoc';
import { triggerHandler } from 'utils/events';
import { SortableList, SortableItem } from './SortableHelpers';

interface ReorderableListProps<T> {
    data: T[];
    renderer(item: T): ReactNode;
    onChange(newData: T[]): void;
}

function ReorderableList<T>({ data, onChange, renderer }: ReorderableListProps<T>) {
    const onSortEnd = ({ oldIndex, newIndex }) => {
        const newArray = arrayMove(data, oldIndex, newIndex);
        triggerHandler(onChange, newArray);
    };

    return (
        <SortableList onSortEnd={onSortEnd} axis="y" lockAxis="y" helperClass={theme.helper} lockToContainerEdges>
            <ul className={theme.list}>
                {data.map((c, i) => (
                    <SortableItem key={i} index={i}>
                        <li className={theme.item}>{renderer(c)}</li>
                    </SortableItem>
                ))}
            </ul>
        </SortableList>
    );
}

export default ReorderableList;